// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NeQG","type":"styles_type__20kJD","choices":"styles_choices__CBLg4"};